export default __webpack_public_path__ + "static/branding3-93601f8a4f341330e3e13013a3a40c0a.webp";